import { IInstructionDTO } from '../../dto/instruction/instruction.dto';
import { IInstructionStepDTO } from '../../dto/instruction/instruction-step.dto';

const instructionStepDTOs: IInstructionStepDTO[] = [
  {
    title: $localize`:@@page-reel-downloader-content-instruction-section-step-0-title:Copy the reel URL`,
    description: $localize`:@@page-reel-downloader-content-instruction-section-step-0-description:Find the reel you want to save on Instagram and copy the link directly from the browser or app.`,
  },
  {
    title: $localize`:@@page-reel-downloader-content-instruction-section-step-1-title:Paste the URL`,
    description: $localize`:@@page-reel-downloader-content-instruction-section-step-1-description:Visit our website and enter the copied URL into the Instagram reels video download tool.`,
  },
  {
    title: $localize`:@@page-reel-downloader-content-instruction-section-step-2-title:Start the download`,
    description: $localize`:@@page-reel-downloader-content-instruction-section-step-2-description:Click the download button and the tool will instantly begin processing your request.`,
  },
  {
    title: $localize`:@@page-reel-downloader-content-instruction-section-step-3-title:Enjoy your saved reels`,
    description: $localize`:@@page-reel-downloader-content-instruction-section-step-3-description:After the download is completed your reels will be ready for viewing whenever you want.`,
  },
];

export const instructionDTO: IInstructionDTO = {
  title: $localize`:@@page-reel-downloader-content-instruction-section-title:How to download Instagram reels`,
  header: $localize`:@@page-reel-downloader-content-instruction-section-header:Here’s how you can get started:`,
  steps: instructionStepDTOs,
  footer: $localize`:@@page-reel-downloader-content-instruction-section-footer:Our platform offers a quick and easy way to download Instagram reels. Start using our service today for fast, hassle-free downloads!`,
};
